import { NEW_ON_EDEL, NEW_ON_EDEL_ERROR, NEW_ON_EDEL_HIDE_ERROR, NEW_ON_EDEL_START_LOADER, NEW_ON_EDEL_STOP_LOADER, } from "../interface/iNewOnEdel";
const initialState = {
    newOnEdelData: [],
    newOnEdelLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const newOnEdelReducer = (state = initialState, action) => {
    switch (action.type) {
        case NEW_ON_EDEL:
            return Object.assign(Object.assign({}, state), { newOnEdelData: action.payload.data });
        case NEW_ON_EDEL_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case NEW_ON_EDEL_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case NEW_ON_EDEL_START_LOADER:
            return Object.assign(Object.assign({}, state), { newOnEdelLoader: true });
        case NEW_ON_EDEL_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { newOnEdelLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default newOnEdelReducer;
